import UpdateEmailCampaignPage from "../../../components/Pages/Campaign/Update/update-email";

const UpdateEmailCampaign = () => {
  return (
    <div>
      <UpdateEmailCampaignPage />
    </div>
  );
};

export default UpdateEmailCampaign;
